import {
  ActionIcon,
  Badge,
  Box,
  Button,
  FileButton,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  rem,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import _breadcrumb from "../../_base/component/_layout/_breadcrumb";
import { useDebouncedState, useDisclosure, useHotkeys } from "@mantine/hooks";
import { _localization } from "../../config/location";
import { useDeferredValue, useEffect, useRef, useState } from "react";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  IconEye,
  IconFileDownload,
  IconFileTypeCsv,
  IconFileUpload,
  IconPhotoUp,
  IconSearch,
} from "@tabler/icons-react";
import { getDataFAQCategory, importFAQs } from "../../api/ApiConfigWeb";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { BASE_API_URL } from "../../config";

const ListCategoryFAQs = () => {
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const [keySearch, setKeySearch] = useDebouncedState<string>("", 300);

  const [file, setFile] = useState<File | null>(null);
  const resetRef = useRef<() => void>(null);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "STT",
        header: "STT",
        size: 50,
        Cell: ({ row }) => (
          <Text fw={500} size="16px">
            {row.index + 1}
          </Text>
        ),
      },
      {
        accessorKey: "categoryName",
        header: "Tên danh mục",
        size: 250,
        Cell: ({ row }) => {
          // const [hovered, setHovered] = React.useState(false);
          return (
            <Badge
              // color={hovered ? "green" : "#1971c2"}
              // onMouseEnter={() => setHovered(true)}
              // onMouseLeave={() => setHovered(false)}
              style={{ width: "fit-content", cursor: "pointer" }}
              // onClick={() => navigate(`/Config/faq/${row.original.id}`)}
            >
              {row.original.categoryName}
            </Badge>
          );
        },
      },
      {
        accessorKey: "countUrl",
        header: "Tổng số",
      },
      {
        accessorKey: "createdDate",
        header: "Ngày tạo",
        Cell: ({ row }) => (
          <Text size="sm">
            {row.original.createdDate
              ? new Date(row.original.createdDate).toLocaleDateString("vi-VN", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : ""}
          </Text>
        ),
      },
      {
        accessorKey: "lastUpdatedDate",
        header: "Ngày cập nhật",
        Cell: ({ row }) => (
          <Text size="sm">
            {row.original.lastUpdatedDate
              ? new Date(row.original.lastUpdatedDate).toLocaleDateString(
                  "vi-VN",
                  {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                  }
                )
              : ""}
          </Text>
        ),
      },
      {
        accessorKey: "actions",
        header: "Thao tác",
        enableSorting: false,
        size: 100,
        Cell: ({ row }) => (
          <Tooltip label="Xem chi tiết">
            <ActionIcon
              variant="light"
              color="blue"
              onClick={() => navigate(`/Config/faq/${row.original.id}`)}
            >
              <IconEye size={18} />
            </ActionIcon>
          </Tooltip>
        ),
      },
    ],
    []
  );

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `?Skip=${pagination.pageIndex * pagination.pageSize}&Take=${
        pagination.pageSize
      }`;

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      const res = await getDataFAQCategory(url);
      if (res && res.success) {
        const result = res.data;
        const item3 = result.find((i: any) => i.id === 3);
        const item4 = result.find((i: any) => i.id === 4);
        const rest = result.filter((i: any) => i.id !== 3 && i.id !== 4);
        setData([
          { ...item3, categoryName: "Sản phẩm (Chi tiết sản phẩm)" },
          { ...item4, categoryName: "Bài viết (Bài tin tức)" },
          ...rest,
        ]);
        setRowCount(res.totalCount);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  useEffect(() => {
    if (file) {
      if (
        file &&
        (file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          file.type === "application/vnd.ms-excel")
      )
        uploadFile(file);
      else NotificationExtension.Fails("File không đúng định đạng Excel !");
    }
  }, [file]);

  const uploadFile = async (e: File) => {
    if (!e) {
      NotificationExtension.Fails("File rỗng hoặc chưa chọn file !");
      return;
    }
    open();
    try {
      const formData = new FormData();
      formData.append("FormFile", e);

      console.log(formData, e, "sdfsdfhisdjfjsdhf");
      // keep using your existing API helper (importFAQs) or replace with the appropriate one
      const resSaveFile = await importFAQs(formData);

      if (resSaveFile && resSaveFile.success) {
        setFile(null);
        NotificationExtension.Success("Import file thành công!");
        setTimeout(() => {
          fetchData();
        }, 1000);
      } else {
        // show server returned details when available
        const msg = resSaveFile?.message || "Import file thất bại !";
        NotificationExtension.Fails(msg);
        setFile(null);
      }
    } catch (err) {
      console.error("Import error:", err);
      NotificationExtension.Fails("Có lỗi khi import file !");
      setFile(null);
    } finally {
      resetRef.current?.();
      close();
    }
  };

  const handleSelectFileSample = async () => {
    open();
    try {
      const token = localStorage.getItem("token");
      await fetch(`${BASE_API_URL}/ImportTemplate/update-faq`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.blob();
          } else {
            throw new Error("Failed to fetch the resource");
          }
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          let filename = "Mau_Import_Excel_FAQs.xlsx";
          const link = document.createElement("a");
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          NotificationExtension.Success("Lấy file mẫu thành công !");
        })
        .catch((error) => {
          console.error("Error:", error);
          NotificationExtension.Fails("Lấy file mẫu thất bại !");
        });
    } catch (error) {
      console.log("Error downloading template:", error);
      NotificationExtension.Fails("Tải file mẫu thất bại");
    } finally {
      close();
    }
  };

  const handleExportExcel = async () => {
    open();
    try {
      let url = "/ExportExcel/export-faq";

      const _url = BASE_API_URL + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        NotificationExtension.Success("Export Excel thành công !");
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "danh_sach_faqs" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  console.log(data, "ádasdasdas");
  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Flex gap={"xs"}>
            <FileButton
              resetRef={resetRef}
              onChange={(file) => {
                if (file) {
                  setFile(file);
                } else {
                  NotificationExtension.Fails("Bạn chưa chọn file tải lên !");
                }
                resetRef.current?.();
              }}
            >
              {(props) => (
                <Button leftSection={<IconFileUpload size={16} />} {...props}>
                  Import Excel
                </Button>
              )}
            </FileButton>
            <Button
              leftSection={<IconFileDownload size={16} />}
              onClick={() => handleSelectFileSample()}
            >
              Lấy file mẫu
            </Button>
            <Button
              leftSection={<IconFileTypeCsv size={16} />}
              onClick={() => handleExportExcel()}
            >
              Export Excel
            </Button>
          </Flex>
        </Flex>
        <Grid>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa tìm kiếm"
              leftSection={<IconSearch size={16} color="#15aabf" />}
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Button
              leftSection={<IconSearch size={16} />}
              onClick={() => fetchData()}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default ListCategoryFAQs;
